import { createFileRoute } from '@tanstack/react-router'
import IntentPage from '../../../features/playbook/components/intent-page'
import { DEFAULT_ORGANIZATION_ID } from '../../../features/playbook/components/overview/channel-filter'

type PlaybookIntentSearch = {
    organizationId?: number
}

export const Route = createFileRoute('/_app/playbook/$intentId')({
    validateSearch: (search: Record<string, unknown>): PlaybookIntentSearch => {
        return {
            organizationId: search.organizationId ? Number(search.organizationId) : DEFAULT_ORGANIZATION_ID,
        }
    },
    component: IntentPage,
})
